import {FormFields} from '../services';
import {PartnerTaxSettingsEditBackendData} from '../types';

const getInitialFormField = (
    data: PartnerTaxSettingsEditBackendData['data'],
): FormFields => ({
    alternateTaxRate: data.alternateTaxRate || '',
    defaultTaxRate: data.defaultTaxRate,
    enableJpWithholdingTax: data.enableJpWithholdingTax,
    taxCombinations:
        data.taxCombinations?.map((item) => ({
            ...item,
            id: item.mid,
        })) || [],
});

export default getInitialFormField;
